import { Fee, FeeConfig, PaymentMethodFee } from '@/views/checkout/interfaces';
import { PAYMENT_METHOD_ID } from '@/core/payment-methods/constants';
import { AVAILABLE_FEE_CONFIGS } from '@/constants/fee';
import { FEE_TYPE } from '@/constants/fee-type';

export function getFeesByUrl(configurations: Array<FeeConfig>, queryParams: Object): Array<Fee> {
    return configurations
        .filter((config) => config.queryParameter && /^[0-9]*$/.test(queryParams[config.queryParameter]))
        .map((config) => ({
            type: config.type,
            amount: config.queryParameter ? +queryParams[config.queryParameter] : 0,
            queryParameter: config.queryParameter
        }));
}

export function filterPaymentMethodFees(
    configurations: Array<FeeConfig>,
    paymentMethodFees: Array<PaymentMethodFee>
): Array<Fee> {
    return paymentMethodFees
        ?.map((paymentMethodFee) => {
            const feeConfig =
                configurations.find((config) => config.paymentMethods?.includes(paymentMethodFee.paymentMethodId));

            return feeConfig
                ? { type: feeConfig.type, amount: paymentMethodFee.fee }
                : { type: FEE_TYPE.None, amount: 0 };
        })
        .filter((fee) => fee.type !== FEE_TYPE.None);
}

export function getPaymentMethodFees(paymentMethodId: PAYMENT_METHOD_ID, fees: Array<Fee>): Array<Fee> {
    return fees.filter((fee) => {
        const feeConfig = AVAILABLE_FEE_CONFIGS.find((config) => config.type === fee.type);

        if (!feeConfig) {
            return false;
        }

        // Empty or undefined payment method list, means that fee is supported by any payment method.
        return !feeConfig?.paymentMethods?.length || feeConfig.paymentMethods?.includes(paymentMethodId);
    });
}

export function getTotalFeeAmount(fees: Array<Fee>): number {
    return fees.reduce((prevVal, currentVal) => prevVal + currentVal.amount, 0);
}
